
<span *ngIf="(component.type == 'editgrid' && component.expanded) || (component.type != 'editgrid' && component.components)">
      <ul *ngFor="let field of component.components" class="list-group list-group--panel flex-grow-1">
          <li [ngClass]="{'active': selectedField == field, 'required':true}" (click)="expand(field);componentSelected(field);" class="list-group-item list-group-item--fields">
              <span class="list-group-item-text">
                  <font>{{ field.label ? field.label : field.key}}
                      <b style="color: red">{{(field.validate && field.validate.required == true) ? ' *' : ''}}</b>
                  </font>
              </span>
          </li>
          <field-tree-node [component]="field" (showFieldOptions)="onClickChild($event)"></field-tree-node>
      </ul>
</span>
<span *ngIf="component.expanded && component.rows">
    <span *ngFor="let tableRow of component.rows">
          <span *ngFor="let cell of tableRow">
              <field-tree-node [component]="cell" (showFieldOptions)="onClickChild($event)"></field-tree-node>
          </span>
    </span>
</span>
<span *ngIf="component.expanded && component.columns">
    <span *ngFor="let columnRow of component.columns">
        <field-tree-node [component]="columnRow" (showFieldOptions)="onClickChild($event)"></field-tree-node>
    </span>
</span>

